import { render, staticRenderFns } from "./FinancePersonTableGrouped.vue?vue&type=template&id=af187b08"
import script from "./FinancePersonTableGrouped.vue?vue&type=script&lang=js"
export * from "./FinancePersonTableGrouped.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports